import React from 'react'
import Hero from '../Sections/Detailing/Hero'
import WhyDetailing from '../Sections/Detailing/WhyDetailng'
import DentRestorationSection from '../Sections/Detailing/DentRestoration'
import DetailingProcessSection from '../Sections/Detailing/DetailiingProcess'
import ProductsAndDentingSection from '../Sections/Detailing/products'
import Final from '../Sections/Detailing/Final'
function Detail() {
  return (
    <>
    <Hero/>
    <WhyDetailing/>
    <DentRestorationSection/>
    <DetailingProcessSection/>
    <ProductsAndDentingSection/>
    <Final/>
    </>
  )
}

export default Detail
